import React, { useEffect, useState } from 'react';
import { auth, db } from '../functions/firebaseFunctions';
import { Navigate, useNavigate } from 'react-router';
import { FiLogOut, FiEdit } from "react-icons/fi";
import {Link} from "react-router-dom"
import CalendarDetail from './CalendarDetail';
import EventsTab from './EventsTab';
import VenuesTab from './VenuesTab';
import ServicesTab from './ServicesTab';
import ConversationsScreen from './ConversationsScreen';
import Transactions from './Transactions';
// import ConversationsScreen from "./ConversationsScreen";
// import MessageBtn from './MessageBtn';

export default function Dashboard() {
    const navigateTo = useNavigate();
    
    const [Err, setErr] = useState(null);
    
    const [eventDates, setEventDates] = useState(null);
    const [myvenueBookDates, setmyvenueBookDates] = useState(null);
    const [venueBookDates, setvenueBookDates] = useState(null);
    const [serBks, setSerBks] = useState(null);
    const [tab, setTab] = useState('');
    
    const [mobilePay, setIsMobilePay] = useState(false);
    const [image, setImage] = useState(null);
    const [name, setname] = useState(null);
    const [AccType, setAccType] = useState(null);
    const [serviceBksCount, setServiceBksCount] = useState(0);
    const [inputText, setInputText] = useState("");
    const [uid, setUid] = useState(null);

    const getData = () => {
        const user = auth.currentUser;
        if (user) {
            setname(user.displayName);
            setImage(user.photoURL);

            db.collection('users').doc(user?.uid).get()
                .then(async (doc) => {
                    const val = doc.data();

                    if (doc.exists) {
                        if (val.isOnboardedStripe) {
                            setIsMobilePay(true);
                        }
                        if (doc.data() && doc.data().type) {
                            const type = doc.data().type;
                            setAccType(type);
                            setImage(doc.data().photo);
                            if (doc.data().photo) {
                                await fetch(doc.data().photo)
                                    .then((response) => response)
                                    .then((data) => {
                                        if (data?.error?.message == 'Permission denied.') {
                                            setImage(null);
                                        }
                                    });
                            }

                        } else {
                            setAccType('Standard');
                        }
                        db
                            .collection('venue')
                            .where('owner', '==', user.uid)
                            .get()
                            .then((doc) => {
                                if (!doc.empty) {
                                    let countVenues = 0;
                                    let countEvents = 0;
                                    const arr = [];
                                    doc.docs.forEach((e) => {
                                        countVenues++;
                                        let venueInfo = e.data();

                                        db
                                            .collection('venue')
                                            .doc(e.data().docid)
                                            .collection('events')
                                            .get()
                                            .then((venEve) => {
                                                if (!venEve.empty) {
                                                    venEve.docs?.forEach((x) => {
                                                        countEvents++;
                                                        let val = x.data();
                                                        let venEvents;
                                                        val.end = val.end.toDate();
                                                        val.start = val.start.toDate();

                                                        val.venueName = venueInfo.name;
                                                        arr.push(val);
                                                    });

                                                    //setCountEve(countEvents);

                                                    if (arr.length == countEvents) {
                                                        setmyvenueBookDates(arr);
                                                    }
                                                }
                                            })
                                            .catch((err) => {
                                                console.log('Err', err);
                                            });
                                    });
                                }
                            })
                            .catch((err) => console.log('err', err));

                        if (val.subscription && val.subscription.length > 0) {
                            const arr = [];

                            let countLocations = 0;
                            let countVenues = 0;
                            let countEvents = 0;
                            val.subscription.map((subs) => {
                                countLocations++;
                                db
                                    .collection('locations')
                                    .where('path', '==', subs.state)
                                    .where('town', '==', subs.town)
                                    .get()
                                    .then((doc) => {
                                        if (!doc.empty) {
                                            let vens = doc.docs[0].data()?.venues;
                                            for (const [id, name] of Object.entries(vens)) {
                                                countVenues++;
                                                db
                                                    .collection('venue')
                                                    .where('venueId', '==', id)
                                                    .get()
                                                    .then((r) => {
                                                        if (!r.empty) {
                                                            let docid = r.docs[0].id;
                                                            db
                                                                .collection('venue')
                                                                .doc(docid)
                                                                .collection('events')
                                                                .get()
                                                                .then((eve) => {
                                                                    if (!eve.empty) {
                                                                        eve.docs.forEach((e) => {
                                                                            let events = e.data();
                                                                            events.venueName = name;
                                                                            arr.push(events);
                                                                            countEvents++;
                                                                            if (
                                                                                countLocations ==
                                                                                val.subscription.length &&
                                                                                countVenues == vens.length &&
                                                                                countEvents == eve.docs.length
                                                                            ) {
                                                                                setvenueBookDates(arr);
                                                                            }
                                                                        });
                                                                    }
                                                                });
                                                        }
                                                    });
                                            }
                                        }
                                    });
                            });
                        }
                    } else {
                        //console.log('No such document!');
                    }
                }).catch((error) => {
                    console.log('Error getting document:', error);
                });
            db.collection('events').where('uid', '==', user.uid).get()
                .then((e) => {
                    const arr = [];
                    let count = 0;
                    if (!e.empty) {
                        e.docs?.forEach((event) => {
                            count++;
                            let obj;
                            let eve = event.data();
                            obj = eve;
                            obj.start = eve.start.toDate();
                            obj.end = eve.end.toDate();

                            arr.push(obj);
                            if (count == e.docs?.length) {
                                setEventDates(arr);
                            }
                        });
                    }
                }).catch((e) => setErr(e));

                db.collection('services').doc(user.uid).collection('events')
                  .onSnapshot(async (serviceEvents) => {
                    const bks = [];
                    let countBook = 0;
                    if (!serviceEvents.empty) {
                      const d = serviceEvents.docs.map(async (events, i) => {
                        let eve = events.data();
                        await db
                          .collection('bookings').doc(eve.docid).get()
                          .then(async (res) => {
                            if (res.exists) {
                              let booking = res.data();
                              const owner = booking.owner;
                              const now = new Date();
                              const date = new Date(booking.date.toDate());
                              await
                                db.collection('bookings').doc(eve.docid).collection('etts').doc(user.uid).get()
                                  .then(async (res) => {
                                    const ett = res.data();
                                    let status = ett.status;
                                    let venName = '';
                                    let vens = await db.collection('bookings').doc(eve.docid).collection('ven').get();
                                    if (!vens.empty) {
                                      venName = vens.docs[0].data().name;
                                    }
                                    if (status != 'Deleted') {
                                      countBook++;
                                      if (now > date) {
                                        status = 'Expired';
                                      }
                                      bks.push({
                                        type: ett.type,
                                        eventId: eve.docid,
                                        status: status,
                                        user: owner,
                                        date: date,
                                        start: date,
                                        end: booking.end.toDate(),
                                        venueName: venName,
                                      });
          
                                      setServiceBksCount(countBook);
                                      if (i + 1 == serviceEvents.docs.length) {
                                        setSerBks(bks);
                                      }
                                    }
                                  });
                            }
                          })
                          .catch((err) => setErr(err));
                      });
                    }
                  });
        }
    };
    
    useEffect(() => {
        if (auth.currentUser) { getData(); }
        // console.log('user id :', auth.currentUser.uid)
    }, []);
    
    function send(text, convId) {
        const update = {}
        const now = new Date()
        const UID = auth.currentUser?.uid
        update[now.valueOf()] = {
            text: text,
            from: uid
        }
        db.collection(`conversations`).doc(UID).update(update).get(() => {
            setInputText("")
        }).catch((e) => { setErr(e) })
    }

    if (auth.currentUser) {


        return (
            <>
                {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
                    <div className='DashboardBlock ' >
                        <h3>User</h3>
                        <div className='dashboardUser' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                            <img alt='Profile_pitcture'
                                src={auth.currentUser.photoURL ? auth.currentUser.photoURL : '/blank-profile-picture.png'}
                                style={{ width: 120, height: 120, borderRadius: 5, margin: 10, objectFit: 'cover'}}
                            />
                        
                            <p style={{ color: 'var(--wht)', fontSize: 24, textAlign: 'center' }}>{auth.currentUser.displayName ? auth.currentUser.displayName : 'Username'}</p>
                            <div >
                                <button className='DashboardButtons'>
                                    <Link to="/Profile/edit" >
                                        <FiEdit className='DashboardIcons' />
                                    </Link>
                                </button>
                                <button className='DashboardButtons'
                                    onClick={async () => {
                                        auth.signOut().then(() => {
                                            navigateTo('/Profile/dashboard');
                                        }).catch(e => {
                                            console.log(e);
                                        });
                                    }}>
                                    <FiLogOut className='DashboardIcons' />
                                </button>
                            </div>
                        </div>
                    </div>
                    
                <div >
                    <div className='DashboardCalendarEvents'>
                        <div className='DashboardBlock' style={{flexDirection: 'column', width: '320px',  }}>
                            <h3>Calendar</h3>
                            <CalendarDetail
                                home={true} //to display some info differently on a home screen
                                eventDates={eventDates}
                                myvenueBookDates={myvenueBookDates}
                                venueBookDates={venueBookDates}
                                serBks={serBks}
                            //setLayout={setCalendarLayout}
                            />
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <div className='DashboardBlock DashboardEvents' >
                                <h3>Events</h3>
                                <EventsTab
                                    uid={auth.currentUser?.uid}
                                    setTab={setTab}
                                />
                            </div>
                            {AccType === "Business" && 
                            <div className='DashboardBlock DashboardEvents' >
                                <h3>Venues</h3>
                                <VenuesTab
                                    mobilePay={mobilePay}
                                    uid={auth.currentUser?.uid}
                                    setTab={setTab}
                                />
                            </div>}
                            {AccType === 'Artist' && 
                            <div className='DashboardBlock DashboardEvents'>
                                <h3>Services</h3>
                                <ServicesTab 
                                    uid={auth.currentUser?.uid}
                                    setTab={setTab}
                                    serBks={serBks?.length === serviceBksCount ? serBks : null}
                                    setSerBks={setSerBks}
                                />
                            </div>
                            }
                        </div>
                    </div>
                </div>
                <div className='DashboardBlock ' >
                    <h3>Conversations</h3>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                        {/* {send("Hi  there!", "y6nb8Dx9HqSS9KgI2PK9kT4MrSK2")} */}
                        <ConversationsScreen />
                    </div>
                </div>
                <div className='DashboardBlock ' >
                    <h3>Transactions</h3>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                        <Transactions />
                    </div>
                </div>
            </>
        )
    } else {
        return (
            <Navigate to="/Profile/login" />
        )
    }
}
